import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

const getSKU = async ({ token }: { token: string }) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-disbursement/pending-invoice-upload`,

      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getSKU;
